import "./style/app.scss";
import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify.js";
import router from "./router";
import store from "./store/store";
import Vue3Tour from 'vue3-tour';
import 'vue3-tour/dist/vue3-tour.css'

import FlashMessengerComponent from "./component/FlashMessengerComponent.vue";
import ScanFilterComponent from "./component/ScanFilterComponent.vue";
import DateTimePickerComponent from "./component/DateTimePickerComponent.vue";
import ServiceSelectorComponent from "./component/ServiceSelectorComponent.vue";
import UserSelectorComponent from "./component/UserSelectorComponent.vue";
import DeviceSelectorComponent from "./component/DeviceSelectorComponent.vue";
import TemplateListComponent from "./component/TemplateListComponent.vue";
import PaginatorComponent from "./component/PaginationComponent.vue";
import ExportCsvFilterComponent from "./component/ExportCsvFilterComponent.vue";
import CsvDownloadLinkComponent from "./component/CsvDownloadLinkComponent.vue";
import ScanCardComponent from "./component/ScanCardComponent.vue";
import Spinner from "./component/SpinnerComponent.vue";
import EditScanComponent from "./component/EditScanComponent.vue";
import { GoogleMap, Marker, InfoWindow  } from 'vue3-google-map';


const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(store);
app.use(Vue3Tour);

app.component('Spinner', Spinner);
app.component('GoogleMap', GoogleMap);
app.component('GoogleMapMarker', Marker);
app.component('InfoWindow', InfoWindow);
app.component('FlashMessengerComponent', FlashMessengerComponent);
app.component('ScanFilter', ScanFilterComponent);
app.component('DateTimePicker', DateTimePickerComponent);
app.component('ServiceSelector', ServiceSelectorComponent);
app.component('UserSelector', UserSelectorComponent);
app.component('DeviceSelector', DeviceSelectorComponent);
app.component('TemplateList', TemplateListComponent);
app.component('Pagination', PaginatorComponent);
app.component('ExportCsvFilter', ExportCsvFilterComponent);
app.component('CsvDownloadLink', CsvDownloadLinkComponent);
app.component('ScanCard', ScanCardComponent);
app.component('EditScan', EditScanComponent);

app.config.globalProperties.$currency = (value) => {
    return '$' + parseFloat(value).toFixed(2);
};

app.config.globalProperties.$capitalize = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
};
app.mount('#app');
export default app;